import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { EmptyState } from "@threadws/jute";

/** The API returns 403 for emails outside its allowed domains. */
export function NotAllowedPage() {
  const { logout } = useKindeAuth();
  return (
    <EmptyState
      title="This account isn't allowed"
      description="Sage is only open to approved email domains. Sign out and try a different account."
      actionLabel="Sign out"
      onAction={() => logout()}
    />
  );
}
